// 埋点源自链接：https://stream.jd.com/ddrx/#/requirement/30712,后续由于埋点事件名称动态化不再使用自动生成埋点工具,
// 故将临时活动落地页的埋点事件注册标独立到cms目录下单独维护更新
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils';
export const PageId = Object.freeze({
  cms_TempoPage: 'cms_TempoPage',
});

interface IPVTrackParamsRecord {
  /** 临时活动页 */
  cms_TempoPage: {
    /** 页面id  */
    page_id: string;
  };
}

const sendPv = {
  /** PV-临时活动页 */
  cms_TempoPage: (page_param: IPVTrackParamsRecord['cms_TempoPage']) => {
    eventTrackingUtils.submitPV({ page_id: page_param.page_id, page_param });
  },
};

interface IExpoTrackParamsRecord {
  /** image组件 */
  cms_TempoPage_image_expo: {
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 页面id  */
    page_id: string;
    /** 位置号  */
    pos: number;
    /** 图片url  */
    img: string;
  };
  /** 小标题组件 */
  cms_TempoPage_subtitle_expo: {
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 页面id  */
    page_id: string;
    /** 位置号  */
    pos: number;
    /** 文本名称  */
    text: string;
  };
  /** 2*2&3*2商品池组件 */
  cms_TempoPage_3or2ProductPool_expo: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 卡片样式  */
    card_type: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 横划商品池组件 */
  cms_TempoPage_HorizontalProductPool_expo: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 导航条组件 */
  cms_TempoPage_anchorbar_expo: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 文本名称  */
    text: string;
  };
  /** 优惠品池组件 */
  cms_TempoPage_BundledealPool_expo: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 活动id  */
    activityid: string;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
  };
  /** 无限feeds流商品池组件 */
  cms_TempoPage_FeedsProductPool_expo: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 大-上图下商卡组件曝光 */
  cms_TempoPage_UpHorizontalProductPoolBig_Expo: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 一行-左图右商卡组件曝光 */
  cms_TempoPage_LeftHorizontalProductPool1_Expo: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 自定义热区图片组件曝光 */
  cms_TempoPage_HotzoneImage_Expo: {
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 页面id  */
    page_id: string;
    /** 位置号  */
    pos: number;
    /** 图片url  */
    img: string;
    /** 位置  */
    index: Array<number>;
    /** 链接信息  */
    url: Array<string>;
  };
  /** 小-上图下商卡组件曝光 */
  cms_TempoPage_UpHorizontalProductPoolSmall_Expo: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 二行-左图右商卡组件曝光 */
  cms_TempoPage_LeftHorizontalProductPool2_Expo: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
}
// 辅助函数：动态生成事件ID
const generateEventId = (baseEventId: string, pageId: string): string => {
  return baseEventId.replace('TempoPage', pageId.replace('cms_', ''));
};

// 修改 getExposureRecord 函数，使其接收 pageId 参数
const getExposureRecord = (pageId: string) => {
  const basePageId = pageId.replace('cms_', '');
  return Object.freeze({
    /** image组件 */
    cms_TempoPage_image_expo: generateEventId('cms_TempoPage_image_expo', pageId),
    /** 小标题组件 */
    cms_TempoPage_subtitle_expo: generateEventId('cms_TempoPage_subtitle_expo', pageId),
    /** 2*2&3*2商品池组件 */
    cms_TempoPage_3or2ProductPool_expo: generateEventId(
      'cms_TempoPage_3or2ProductPool_expo',
      pageId,
    ),
    /** 横划商品池组件 */
    cms_TempoPage_HorizontalProductPool_expo: generateEventId(
      'cms_TempoPage_HorizontalProductPool_expo',
      pageId,
    ),
    /** 导航条组件 */
    cms_TempoPage_anchorbar_expo: generateEventId('cms_TempoPage_anchorbar_expo', pageId),
    /** 优惠品池组件 */
    cms_TempoPage_BundledealPool_expo: generateEventId('cms_TempoPage_BundledealPool_expo', pageId),
    /** 无限feeds流商品池组件 */
    cms_TempoPage_FeedsProductPool_expo: generateEventId(
      'cms_TempoPage_FeedsProductPool_expo',
      pageId,
    ),
    /** 大-上图下商卡组件曝光 */
    cms_TempoPage_UpHorizontalProductPoolBig_Expo: generateEventId(
      'cms_TempoPage_UpHorizontalProductPoolBig_Expo',
      pageId,
    ),
    /** 一行-左图右商卡组件曝光 */
    cms_TempoPage_LeftHorizontalProductPool1_Expo: generateEventId(
      'cms_TempoPage_LeftHorizontalProductPool1_Expo',
      pageId,
    ),
    /** 自定义热区图片组件曝光 */
    cms_TempoPage_HotzoneImage_Expo: generateEventId('cms_TempoPage_HotzoneImage_Expo', pageId),
    /** 小-上图下商卡组件曝光 */
    cms_TempoPage_UpHorizontalProductPoolSmall_Expo: generateEventId(
      'cms_TempoPage_UpHorizontalProductPoolSmall_Expo',
      pageId,
    ),
    /** 二行-左图右商卡组件曝光 */
    cms_TempoPage_LeftHorizontalProductPool2_Expo: generateEventId(
      'cms_TempoPage_LeftHorizontalProductPool2_Expo',
      pageId,
    ),
  });
};

interface IClickTrackParamsRecord {
  /** 2*2&3*2商品池组件 */
  cms_TempoPage_3or2ProductPool_click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 卡片样式  */
    card_type: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 2*2&3*2商品池组件加车点击 */
  cms_TempoPage_3or2ProductPool_addtocart_click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 卡片样式  */
    card_type: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 横划商品池组件 */
  cms_TempoPage_HorizontalProductPool_click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 横划商品池组件加车点击 */
  cms_TempoPage_HorizontalProductPool_addtocart_click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 导航条组件 */
  cms_TempoPage_anchorbar_click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 文本名称  */
    text: string;
  };
  /** 优惠品池组件 */
  cms_TempoPage_BundledealPool_click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 活动id  */
    activityid: string;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
  };
  /** 优惠品池组件加车点击 */
  cms_TempoPage_BundledealPool_addtocart_click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 活动id  */
    activityid: string;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
  };
  /** 无限feeds流商品池组件 */
  cms_TempoPage_FeedsProductPool_click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 无限feeds流组件加车点击 */
  cms_TempoPage_FeedsProductPool_addtocart_click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法参数  */
    broker_info: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
  };
  /** 大-上图下商卡组件点击 */
  cms_TempoPage_UpHorizontalProductPoolBig_Click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 大-上图下商卡组件加车点击 */
  cms_TempoPage_UpHorizontalPageBig_Addtocart_Click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 一行-左图右商卡组件点击 */
  cms_TempoPage_LeftHorizontalProductPool1_Click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 自定义热区图片组件点击 */
  cms_TempoPage_HotzoneImage_click: {
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 页面id  */
    page_id: string;
    /** 位置号  */
    pos: number;
    /** 图片url  */
    img: string;
    /** 位置  */
    index: Array<number>;
    /** 链接信息  */
    url: Array<string>;
  };
  /** 小-上图下商卡组件点击 */
  cms_TempoPage_UpHorizontalProductPoolSmall_Click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    algo_rd_inf: string;
    /** 算法参数  */
    broker_info: string;
  };
  /** 二行-左图右商卡组件点击 */
  cms_TempoPage_LeftHorizontalProductPool2_Click: {
    /** 页面id  */
    page_id: string;
    /** 模块实例ID  */
    moduleInstanceId: string;
    /** 位置号  */
    pos: number;
    /** 位置  */
    index: number;
    /** 商品id  */
    skuid: string;
    /** 商品池id  */
    propoolid: string;
    /** 算法埋点信息  */
    /** 算法参数  */
    broker_info: string;
  };
}

const sendClickTrack = {
  /** 点击事件上报-2*2&3*2商品池组件 */
  cms_TempoPage_3or2ProductPool_click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_3or2ProductPool_click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId('cms_TempoPage_3or2ProductPool_click', json_param.page_id),
      json_param,
    });
  },
  /** 点击事件上报-2*2&3*2商品池组件加车点击 */
  cms_TempoPage_3or2ProductPool_addtocart_click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_3or2ProductPool_addtocart_click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId(
        'cms_TempoPage_3or2ProductPool_addtocart_click',
        json_param.page_id,
      ),
      json_param,
    });
  },
  /** 点击事件上报-横划商品池组件 */
  cms_TempoPage_HorizontalProductPool_click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_HorizontalProductPool_click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId('cms_TempoPage_HorizontalProductPool_click', json_param.page_id),
      json_param,
    });
  },
  /** 点击事件上报-横划商品池组件加车点击 */
  cms_TempoPage_HorizontalProductPool_addtocart_click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_HorizontalProductPool_addtocart_click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId(
        'cms_TempoPage_HorizontalProductPool_addtocart_click',
        json_param.page_id,
      ),
      json_param,
    });
  },
  /** 点击事件上报-导航条组件 */
  cms_TempoPage_anchorbar_click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_anchorbar_click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId('cms_TempoPage_anchorbar_click', json_param.page_id),
      json_param,
    });
  },
  /** 点击事件上报-优惠品池组件 */
  cms_TempoPage_BundledealPool_click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_BundledealPool_click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId('cms_TempoPage_BundledealPool_click', json_param.page_id),
      json_param,
    });
  },
  /** 点击事件上报-优惠品池组件加车点击 */
  cms_TempoPage_BundledealPool_addtocart_click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_BundledealPool_addtocart_click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId('cms_TempoPage_BundledealPool_addtocart_click', json_param.page_id),
      json_param,
    });
  },
  /** 点击事件上报-无限feeds流商品池组件 */
  cms_TempoPage_FeedsProductPool_click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_FeedsProductPool_click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId('cms_TempoPage_FeedsProductPool_click', json_param.page_id),
      json_param,
    });
  },
  /** 点击事件上报-无限feeds流组件加车点击 */
  cms_TempoPage_FeedsProductPool_addtocart_click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_FeedsProductPool_addtocart_click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId(
        'cms_TempoPage_FeedsProductPool_addtocart_click',
        json_param.page_id,
      ),
      json_param,
    });
  },
  /** 点击事件上报-大-上图下商卡组件点击 */
  cms_TempoPage_UpHorizontalProductPoolBig_Click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_UpHorizontalProductPoolBig_Click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId(
        'cms_TempoPage_UpHorizontalProductPoolBig_Click',
        json_param.page_id,
      ),
      json_param,
    });
  },
  /** 点击事件上报-大-上图下商卡组件加车点击 */
  cms_TempoPage_UpHorizontalPageBig_Addtocart_Click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_UpHorizontalPageBig_Addtocart_Click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId(
        'cms_TempoPage_UpHorizontalPageBig_Addtocart_Click',
        json_param.page_id,
      ),
      json_param,
    });
  },
  /** 点击事件上报-一行-左图右商卡组件点击 */
  cms_TempoPage_LeftHorizontalProductPool1_Click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_LeftHorizontalProductPool1_Click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId(
        'cms_TempoPage_LeftHorizontalProductPool1_Click',
        json_param.page_id,
      ),
      json_param,
    });
  },
  /** 点击事件上报-自定义热区图片组件点击 */
  cms_TempoPage_HotzoneImage_click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_HotzoneImage_click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId('cms_TempoPage_HotzoneImage_click', json_param.page_id),
      json_param,
    });
  },
  /** 点击事件上报-小-上图下商卡组件点击 */
  cms_TempoPage_UpHorizontalProductPoolSmall_Click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_UpHorizontalProductPoolSmall_Click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId(
        'cms_TempoPage_UpHorizontalProductPoolSmall_Click',
        json_param.page_id,
      ),
      json_param,
    });
  },
  /** 点击事件上报-二行-左图右商卡组件点击 */
  cms_TempoPage_LeftHorizontalProductPool2_Click: (
    json_param: IClickTrackParamsRecord['cms_TempoPage_LeftHorizontalProductPool2_Click'],
  ) => {
    eventTrackingUtils.submitCL({
      event_id: generateEventId(
        'cms_TempoPage_LeftHorizontalProductPool2_Click',
        json_param.page_id,
      ),
      json_param,
    });
  },
};

const EXPOSURE_RECORD = getExposureRecord('cms_TempoPage');
export { EXPOSURE_RECORD, getExposureRecord, sendClickTrack, sendPv };
export type { IExpoTrackParamsRecord };
